document.addEventListener("DOMContentLoaded", function() {
  async function fetchArtistName(productGid) {
    if (!productGid.includes("gid://")) {
       productGid = `gid://shopify/Product/${productGid}`;
    }
    
    const storefrontUrl = "https://wdxugd-yq.myshopify.com/api/2023-10/graphql.json";  // Ersätt med din Storefront URL
    const accessToken = "a36d035e6554c29a534b9afa0d102ffe";      // Ersätt med ditt Access Token

    const query = `
      query getProductArtist($id: ID!) {
        product(id: $id) {
          metafield(namespace: "custom", key: "artist") {
            reference {
              ... on Metaobject {
                field(key: "namn") {
                  value
                }
              }
            }
          }
        }
      }
    `;
    
    const variables = { id: productGid };

    try {
      const response = await fetch(storefrontUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": accessToken
        },
        body: JSON.stringify({ query, variables })
      });
      
      const result = await response.json();
      if (
        result.data &&
        result.data.product &&
        result.data.product.metafield &&
        result.data.product.metafield.reference &&
        result.data.product.metafield.reference.field
      ) {
        return result.data.product.metafield.reference.field.value;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error fetching artist metafield:", error);
      return null;
    }
  }

async function updateArtistCards() {
  const productCards = Array.from(document.querySelectorAll(".card-product[data-product-gid]"));
  
  const promises = productCards.map(async (card) => {
    let gid = card.getAttribute("data-product-gid");
    if (!gid) return;
    if (!gid.includes("gid://")) {
      gid = `gid://shopify/Product/${gid}`;
    }
    const artistName = await fetchArtistName(gid);
    const artistEl = card.querySelector(".artist-card");
    if (artistEl) {
      // Om artistName hittas, visa det; annars lämna fältet tomt
      artistEl.textContent = artistName || "";
    }
  });
  
  await Promise.all(promises);
}


  updateArtistCards();

  // ─────────────────────────────────────────────
  // Global fetchProductData – denna funktion hämtar produktdata
  // (titel, handle, featuredImage) via Storefront API och returnerar ett objekt.
  // Denna funktion används av wishlist.js.
  // Ändra INTE övrig funktionalitet.
  // ─────────────────────────────────────────────
  window.fetchProductData = async function(productGid) {
    if (!productGid.includes("gid://")) {
      productGid = `gid://shopify/Product/${productGid}`;
    }
    
    const storefrontUrl = "https://wdxugd-yq.myshopify.com/api/2023-10/graphql.json";  // Ersätt med din Storefront URL
    const accessToken = "a36d035e6554c29a534b9afa0d102ffe";      // Ersätt med ditt Access Token
    
    const query = `
      query getProductData($id: ID!) {
        product(id: $id) {
          title
          handle
          featuredImage {
            url
          }
        }
      }
    `;
    
    const variables = { id: productGid };

    try {
      const response = await fetch(storefrontUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": accessToken
        },
        body: JSON.stringify({ query, variables })
      });
      
      const result = await response.json();
      if (result.data && result.data.product) {
        const product = result.data.product;
        return {
          title: product.title,
          handle: product.handle,
          image: product.featuredImage ? product.featuredImage.url : null
        };
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
      return null;
    }
  }
});